<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout column align-center justify-center>
      <v-card
        width="100%"
        max-width="500"
        max-height="500"
        outlined
        class="overflow-y-auto">
        <v-card-title>
          {{ $t('auth.selectRestaurant') }}
        </v-card-title>
        <v-layout wrap>
          <v-flex md12>
            <v-list-item
              v-for="restaurant in restaurants"
              :key="restaurant._id"
              @click="selectRestaurant(restaurant)"
            >
              <v-list-item-avatar>
                <v-avatar color="primary" size="36">
                  <span class="white--text headline">{{ restaurant.name | initial }}</span>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="restaurant.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
      </v-card>
      <v-btn href="/logout" text rounded class="ma-2 red--text">Cerrar sesión</v-btn>
    </v-layout>

    <AcceptCookies ref="acceptCookies" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AcceptCookies from '@/components/modals/AcceptCookies'
import VueCookie from 'vue-cookie'
import moment from 'moment'

export default {
  data () {
    return {
      overlay: false
    }
  },
  components: {
    AcceptCookies
  },
  async beforeMount () {
    if (!this.userId) {
      this.$router.push('/logout')
    }
    if (!this.restaurants.length) {
      this.$router.push({ name: 'Welcome' })
    }
  },
  mounted () {
    this.validateCookies()
  },
  computed: {
    ...mapState({
      restaurants: state => state.login.restaurants.data,
      areas: state => state.currentRestaurant.areas.data
    }),
    ...mapGetters(['allowedAreas']),
    userId () {
      return this.$store.state.login.user._id
    }
  },
  methods: {
    ...mapActions([
      'currentRestaurant/select'
    ]),
    async selectRestaurant (restaurant) {
      await this['currentRestaurant/select'](restaurant)
      await this.$store.commit('setArea', this.allowedAreas[0])
      await this.updateLastLogin({ restaurant: restaurant._id })
      const urls = {
        manager: 'Recipes',
        stockmanager: 'CaptureInventory',
        chef: 'Recipes',
        buyer: 'Dishes',
        sales: 'Sales',
        financier: 'Accounts'
      }
      this.$router.push({ name: urls[this.$is()] })
    },
    validateCookies () {
      const cookie = VueCookie.get('expirationDate')
      if (!cookie || cookie < new Date()) {
        this.$refs.acceptCookies.openDialog()
      }
    },
    async updateLastLogin (params) {
      await this.$api.post(`/v1/restaurants/${params.restaurant}`, { lastLogin: moment().format('YYYY-MM-DD HH:mm:ss') })
    }
  }
}
</script>
